// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nJ-z","twoColumnImage":"oJ-z"};